// extracted by mini-css-extract-plugin
export default {"form":"EventForm_form__PoEvc","title":"EventForm_title__YYnPw","button":"EventForm_button__JJTnj"};